export const INITIALIZATION_STATUS = {
    UNKNOWN: 'UNKNOWN',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
};
